import { startLoading, stopLoading } from 'app/modules/cms/service/store/cms-dispatchs';
import { ContactDTO } from 'app/shared/model/contactDTO.model';
import { DocumentDTO } from 'app/shared/model/documentDTO.model';
import { FeedBackDTO } from 'app/shared/model/FeedBackDTO.model';
import { clientApi } from '../api/client-api';
import { getNextStep } from './step-engine-service';


export const createContact = (contact: ContactDTO) => async (dispatch) => {
    try {
        const response = await clientApi.createContact(contact);
        if (response.status === 200 || response.status === 201) {
            return response.data;
        } else {
            throw new Error("Erreur lors de la création de contact'");
        }
    } catch (err) {
        throw new Error(err);
    }
};

export const createFirstContact = (contact: ContactDTO) => async (dispatch) => {
    try {
        const response = await clientApi.createFirstContact(contact);
        if (response.status === 200 || response.status === 201) {
            return response.data;
        } else {
            throw new Error("Erreur lors de la création de contact'");
        }
    } catch (err) {
        throw new Error(err);
    }
};

export const createDocument = (documents: DocumentDTO[]) => async (dispatch) => {
    try {
        const response = await clientApi.createDocument(documents);
        if (response.status === 200 || response.status === 201) {
            return response.data;
        } else {
            throw new Error("Erreur lors de la création des documents'");
        }
    } catch (err) {
        throw new Error(err);
    }
};

export const contactFormTransmit = (contact: ContactDTO, documents: DocumentDTO[]) => async (dispatch) => {
    dispatch(startLoading());
    await dispatch(createContact(contact));
    if (documents.length > 0) {
        await dispatch(createDocument(documents))
        await dispatch(getNextStep());
    } else {
        await dispatch(getNextStep());
    }
    dispatch(stopLoading());
}

export const createFeedBack = (documents: FeedBackDTO) => async (dispatch) => {
    try {
        const response = await clientApi.createFeedBack(documents);
        if (response?.status === 200 || response?.status === 201) {
            return response.data;
        } else {
            throw new Error("Erreur lors de la création du FeedBack'");
        }
    } catch (err) {
        throw new Error(err);
    }
};